
import { useEffect } from "react";
import Header from "@/components/Header";
import FooterSection from "@/components/FooterSection";
import EducationHero from "@/components/education/EducationHero";
import ContinuedEducation from "@/components/education/ContinuedEducation";
import SelfPacedLearning from "@/components/education/SelfPacedLearning";
import EducationCurriculum from "@/components/education/EducationCurriculum";
import EducationTestimonials from "@/components/education/EducationTestimonials";
import EducationCTA from "@/components/education/EducationCTA";

const Education = () => {
  useEffect(() => {
    document.title = "AI Legal Education & Training | DocketLabs";
    window.scrollTo(0, 0);
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional AI education for lawyers. Continued learning programs, certifications & practical training. Advance your legal career.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Professional AI education for lawyers. Continued learning programs, certifications & practical training. Advance your legal career.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <EducationHero />
      <ContinuedEducation />
      <SelfPacedLearning />
      <EducationCurriculum />
      <EducationTestimonials />
      <EducationCTA />
      <FooterSection />
    </div>
  );
};

export default Education;
